import Vue from 'vue'
import { isString, isArray, isNumeric, isObject, isBoolean, isDefined } from './types.js'

const bus = new Vue()

const contentAssetPath = (path) => {
    if (window.location.hostname.match(/localhost/)) {
        return path
    } else if (isString(path) && window.hasOwnProperty('composed_gift_guide_content_asset_path')) {
        return window.composed_gift_guide_content_asset_path.concat(path)
    }
}

export {
    bus,
    contentAssetPath,
    isString,
    isArray,
    isNumeric,
    isObject,
    isBoolean,
    isDefined,
}


// WEBPACK FOOTER //
// ./src/js/app/utilities/index.js